import { isNullOrUndefined, extend } from '@syncfusion/ej2-base';
import { DataManager, Query, Deferred, Predicate, DataUtil } from '@syncfusion/ej2-data';
import { initForeignKeyColumn, getForeignKeyData, generateQuery } from '../base/constant';
import { getDatePredicate } from '../base/util';
import { Data } from './data';
import * as events from '../base/constant';
/**
 * `ForeignKey` module is used to handle foreign key column's actions.
 */
export class ForeignKey extends Data {
    constructor(parent, serviceLocator) {
        super(parent, serviceLocator);
        this.parent = parent;
        this.serviceLocator = serviceLocator;
        this.initEvent();
    }
    initEvent() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.on(initForeignKeyColumn, this.initForeignKeyColumns, this);
        this.parent.on(getForeignKeyData, this.getForeignKeyData, this);
        this.parent.on(generateQuery, this.generateQueryFormData, this);
    }
    initForeignKeyColumns(columns) {
        for (let i = 0; i < columns.length; i++) {
            columns[parseInt(i.toString(), 10)].dataSource = (columns[parseInt(i.toString(), 10)].dataSource instanceof DataManager ?
                columns[parseInt(i.toString(), 10)].dataSource :
                (isNullOrUndefined(columns[parseInt(i.toString(), 10)].dataSource) ? new DataManager() :
                    'result' in columns[parseInt(i.toString(), 10)].dataSource ? columns[parseInt(i.toString(), 10)].dataSource :
                        new DataManager(columns[parseInt(i.toString(), 10)].dataSource)));
        }
    }
    eventfPromise(args, query, key, column) {
        const state = this.getStateEventArgument(query);
        const def = new Deferred();
        const deff = new Deferred();
        state.action = args.action;
        const dataModule = this.parent.getDataModule();
        if (!isNullOrUndefined(args.action) && args.action.requestType && dataModule.foreignKeyDataState.isDataChanged !== false) {
            dataModule.setForeignKeyDataState({
                isPending: true, resolver: deff.resolve
            });
            deff.promise.then(() => {
                def.resolve(column.dataSource);
            });
            state.setColumnData = this.parent.setForeignKeyData.bind(this.parent);
            this.parent.trigger(events.columnDataStateChange, state);
        }
        else {
            dataModule.setForeignKeyDataState({});
            def.resolve(key);
        }
        return def;
    }
    getForeignKeyData(args) {
        let foreignColumns = args.column ? [args.column] : this.parent.getForeignKeyColumns();
        if (this.parent.columnQueryMode === 'ExcludeHidden') {
            foreignColumns = foreignColumns.filter((col) => col.visible !== false);
        }
        const allPromise = [];
        for (let i = 0; i < foreignColumns.length; i++) {
            let promise;
            const query = args.isComplex ? this.genarateColumnQuery(foreignColumns[parseInt(i.toString(), 10)]) :
                this.genarateQuery(foreignColumns[parseInt(i.toString(), 10)], args.result.result, false, true);
            query.params = this.parent.query.params;
            const dataSource = foreignColumns[parseInt(i.toString(), 10)].dataSource;
            if (dataSource && 'result' in dataSource) {
                const def = this.eventfPromise(args, query, dataSource, foreignColumns[parseInt(i.toString(), 10)]);
                promise = def.promise;
            }
            else if (!dataSource.ready || dataSource.dataSource.offline) {
                promise = dataSource.executeQuery(query);
            }
            else {
                promise = dataSource.ready.then(() => {
                    return dataSource.executeQuery(query);
                });
            }
            allPromise.push(promise);
        }
        Promise.all(allPromise).then((responses) => {
            for (let i = 0; i < responses.length; i++) {
                foreignColumns[parseInt(i.toString(), 10)].columnData = responses[parseInt(i.toString(), 10)].result;
                if (foreignColumns[parseInt(i.toString(), 10)].editType === 'dropdownedit' && 'result' in foreignColumns[parseInt(i.toString(), 10)].dataSource) {
                    foreignColumns[parseInt(i.toString(), 10)].edit.params = extend(foreignColumns[parseInt(i.toString(), 10)]
                        .edit.params, {
                        dataSource: responses[parseInt(i.toString(), 10)].result,
                        query: new Query(), fields: {
                            value: foreignColumns[parseInt(i.toString(), 10)].foreignKeyField ||
                                foreignColumns[parseInt(i.toString(), 10)].field,
                            text: foreignColumns[parseInt(i.toString(), 10)].foreignKeyValue
                        }
                    });
                }
            }
            args.promise.resolve(args.result);
        }).catch((e) => {
            let errorMsg = e;
            if (!errorMsg.error) {
                errorMsg = { error: errorMsg };
            }
            this.parent.log(['actionfailure', 'foreign_key_failure'], errorMsg);
            if (args.promise && args.promise.reject) {
                args.promise.reject(e);
            }
            return e;
        });
    }
    generateQueryFormData(args) {
        args.predicate.predicate = this.genarateQuery(args.column, args.column.columnData, true);
    }
    genarateQuery(column, e, fromData, needQuery) {
        const gObj = this.parent;
        const predicates = [];
        const query = new Query();
        let field = fromData ? column.foreignKeyField : column.field;
        if (this.parent.searchSettings && this.parent.searchSettings.key.length) {
            const query = new Query().where(column.foreignKeyValue, 'contains', this.parent.searchSettings.key, true);
            e = new DataManager((e)).executeLocal(query);
        }
        if (gObj.allowPaging || gObj.enableVirtualization || fromData) {
            e = new DataManager(((gObj.allowGrouping && gObj.groupSettings.columns.length && !fromData) ?
                e.records : e)).executeLocal(new Query().select(field));
            const filteredValue = DataUtil.distinct(e, field, false);
            field = fromData ? column.field : column.foreignKeyField;
            for (let i = 0; i < filteredValue.length; i++) {
                if (filteredValue[parseInt(i.toString(), 10)] && filteredValue[parseInt(i.toString(), 10)].getDay) {
                    predicates.push(getDatePredicate({ field: field, operator: 'equal', value: filteredValue[parseInt(i.toString(), 10)], matchCase: false }));
                }
                else {
                    predicates.push(new Predicate(field, 'equal', filteredValue[parseInt(i.toString(), 10)], false));
                }
            }
        }
        if (needQuery) {
            return predicates.length ? query.where(Predicate.or(predicates)) : query;
        }
        return (predicates.length ? Predicate.or(predicates) : { predicates: [] });
    }
    genarateColumnQuery(column) {
        const gObj = this.parent;
        let query = new Query();
        const queryColumn = this.isFiltered(column);
        if (queryColumn.isTrue) {
            query = this.filterQuery(query, queryColumn.column, true);
        }
        if (gObj.searchSettings.key.length) {
            const sSettings = gObj.searchSettings;
            if (column.dataSource instanceof DataManager && (column.dataSource.adaptor.getModuleName &&
                column.dataSource.adaptor.getModuleName() === 'ODataV4Adaptor')) {
                query = this.searchQuery(query, column, true);
            }
            else {
                query.search(sSettings.key, column.foreignKeyValue, sSettings.operator, sSettings.ignoreCase);
            }
        }
        return query;
    }
    isFiltered(column) {
        const filterColumn = this.parent.filterSettings.columns.filter((fColumn) => {
            return (fColumn.field === column.foreignKeyValue && fColumn.uid === column.uid);
        });
        return {
            column: filterColumn, isTrue: !!filterColumn.length
        };
    }
    getModuleName() {
        return 'foreignKey';
    }
    destroy() {
        this.destroyEvent();
    }
    destroyEvent() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off(initForeignKeyColumn, this.initForeignKeyColumns);
        this.parent.off(getForeignKeyData, this.getForeignKeyData);
        this.parent.off(generateQuery, this.generateQueryFormData);
    }
}
